import { Link } from "react-router";
import { appPaths } from "../../shared/routing/appPaths";
import { useTranslation } from "react-i18next";
import type { Batch } from "../../api/threads/batchesApi";

export function PlanResults({ batch }: { batch: Batch }) {
  const { t } = useTranslation();
  if (batch.planDigest === null) return null;
  return <section className="space-y-2 text-sm">
    <h3 className="app-title font-semibold">{t("batches.planUnits")}</h3>
    <p className="app-text-muted break-all text-xs">{batch.planDigest}</p>
    <ul>{batch.units.map((unit) => <li key={unit.unit}>{unit.unit}{unit.dependsOn.length ? ` · ${t("batches.dependsOn")}: ${unit.dependsOn.join(", ")}` : ""}</li>)}</ul>
    {batch.unplannable.map((vita) => <p key={vita.vita} className="break-all">{t("batches.unplannable")}: {vita.vita} · {vita.reason}</p>)}
    <h3 className="app-title font-semibold">{t("batches.vitaAssemblies")}</h3>
    <ul className="space-y-2">{batch.assemblies.map((assembly) => <li key={assembly.vita} className="break-all">
      <Link className="app-link underline" to={appPaths.batchVita(batch.batchId, assembly.vita)}>{assembly.vita}</Link> · {t(assembly.complete ? "batches.complete" : "batches.partial")}
      {assembly.missingUnits.length ? <p>{t("batches.missingUnits")}: {assembly.missingUnits.join(", ")}</p> : null}
      <p className="app-text-muted text-xs">{assembly.digest}</p>
      <ul>{assembly.partOutputs.map((output) => <li key={output}>{output}</li>)}</ul>
    </li>)}</ul>
  </section>;
}
